import * as Yup from "yup";
import { useEffect, useState } from "react";
import { useBoolean } from "../../../../../hooks/use-boolean";
import { IBranch } from "../../../../../types/branch";
import { IDepartment } from "../../../../../types/department";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { IUserUpdateData } from "../../../../../types/user";
import { AllBranchesService } from "../../../../../services/branches";
import { enqueueSnackbar } from "notistack";
import { AllDepartmentsService } from "../../../../../services/departments";
import { GetUserByIdService, UpdateUserService } from "../../../../../services/users";
import { useParams } from "react-router-dom";
import { useRouter } from "../../../../../routes/hooks";

const useUpdateDataUser = () => {

    const loading = useBoolean(true);
    const router = useRouter();

    const { id } = useParams();

    const [branches, setBranches] = useState<IBranch[]>([]);
    const [departments, setDepartments] = useState<IDepartment[]>([]);

    const [selectedBranch, setSelectedBranch] = useState<IBranch | null>(null);
    const [selectedDepartment, setSelectedDepartment] = useState<IDepartment | null>(null);

    const UpdateDataUserSchema = Yup.object().shape({
        name: Yup.string().required('Informe o nome do usuário').max(255, 'O nome deve conter no máximo 255 caracteres'),
        username: Yup.string().required('Informe o username do usuário').max(255, 'O username deve conter no máximo 255 caracteres'),
        email: Yup.string().email('Informe um e-mail válido').required('Informe o e-mail do usuário').max(255, 'O e-mail deve conter no máximo 255 caracteres'),
        branch: Yup.object().shape(
            {
                id: Yup.number().required().required('Selecione um departamento'),
                code: Yup.string().required().required('Selecione um departamento'),
                name: Yup.string().required().required('Selecione um departamento')
            }
        ).required("Selecione uma filial"),
        department: Yup.object().shape(
            {
                id: Yup.number().required('Selecione um departamento'),
                name: Yup.string().required('Selecione um departamento'),                          
            }
        ).required('Selecione um departamento'),
    });

    const methods = useForm({
        resolver: yupResolver<IUserUpdateData>(UpdateDataUserSchema),
        defaultValues: {
            name: '',
            username: '',
            email: '',
            branch: null!,
            department: null!
        }
    });

    const {
        handleSubmit,
        formState: { isSubmitting },
        setValue
    } = methods;

    const getData = async () => {

        loading.onTrue();

        await AllBranchesService().then(resp => {
            setBranches(resp.data);
        }).catch(error => {
            enqueueSnackbar(error?.response?.data?.message || 'Ocorreu um erro', {
                variant: 'error'
            });
        });

        await AllDepartmentsService().then(resp => {
            setDepartments(resp.data);
        }).catch(error => {
            enqueueSnackbar(error?.response?.data?.message || 'Ocorreu um erro', {
                variant: 'error'
            });
        });

    }

    const getUser = async () => {

        await GetUserByIdService(parseInt(id!)).then(resp => {
            setValue("name", resp.data.name, { shouldValidate: true });
            setValue("username", resp.data.username, { shouldValidate: true });
            setValue("email", resp.data.email, { shouldValidate: true });
            setValue("department", resp.data.department, { shouldValidate: true });
            setValue("branch", resp.data.department.branch, { shouldValidate: true });            
            setSelectedBranch(resp.data.department.branch);
            setSelectedDepartment(resp.data.department);

        }).catch(error => {
            enqueueSnackbar(error?.response?.data?.message || 'Ocorreu um erro', {
                variant: 'error'
            });
            router.push('/users');
        });

        loading.onFalse();

    }

    const onSubmit = handleSubmit(async (data: IUserUpdateData) => {

        await UpdateUserService(parseInt(id!), data).then(resp => {
            enqueueSnackbar(resp.data.message);
            router.push('/users');
        }).catch(error => {
            enqueueSnackbar(error?.response?.data?.message || 'Ocorreu um erro', {
                variant: 'error'
            });
        });

    });

    useEffect(() => {
        if(departments?.length > 0 && branches.length > 0)
        {
            getUser();
        }
    }, [departments, branches]);

    useEffect(() => {
        getData();
    }, []);

    return {
        branches,
        departments,
        selectedBranch,
        setSelectedBranch,
        selectedDepartment,
        setSelectedDepartment,
        methods,
        onSubmit,
        setValue,
        isSubmitting
    }
}

export default useUpdateDataUser;